// extracted by mini-css-extract-plugin
export default {"container":"SimpleListViewContainer-module__container--nwHdB"};